import { Component, Output, OnInit, EventEmitter } from '@angular/core';
import { GameSetUpService } from '../../providers/gameSetUp.service';
import { LastGamesService } from '../../providers/lastGames.service';



@Component({
    selector: 'set-up-component',
    templateUrl: './set-up.component.html',
    styleUrls: ['./set-up.component.scss']
})
export class SetUpComponent implements OnInit {

    @Output() createGame = new EventEmitter();

    public setUpState: number = 0;
    public isStandard: boolean = false;
    public showSettings: boolean = false;


    constructor(public gameSetUpService: GameSetUpService, public lastGamesService: LastGamesService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        // setTimeout(_ => /*code*/ );
    }

    ngOnChanges() {
    }

    getTeams() {
        let teams = [];

        for (let i = 0; i < this.gameSetUpService.teamCount; i++) {
            teams.push(this.gameSetUpService.teams[i]);
        }

        return teams;
    }


    onStepForward() {
        this.setUpState++;
    }

    onStepBack() {
        if (this.setUpState == 3 && this.isStandard) {
            this.setUpState -= 2;
            this.isStandard = false;
        } else {
            this.setUpState--;
        }
    }


    onStandard() {
        this.gameSetUpService.points = 301;
        this.gameSetUpService.sets = 1;
        this.gameSetUpService.legs = 3;
        this.gameSetUpService.throws = 3;

        this.onStepForward();
        this.onStepForward();
        this.isStandard = true;
    }

    onPredefined() {
        this.gameSetUpService.points = this.gameSetUpService.predefinedSetUp.points;
        this.gameSetUpService.sets = this.gameSetUpService.predefinedSetUp.sets;
        this.gameSetUpService.legs = this.gameSetUpService.predefinedSetUp.legs;
        this.gameSetUpService.throws = 3;
        this.gameSetUpService.countUpRounds = this.gameSetUpService.predefinedSetUp.countUpRounds;
        this.gameSetUpService.teamCount = this.gameSetUpService.predefinedSetUp.teamCount;
    }

    onCustom() {
        this.onStepForward();

    }

    onCreateGame() {
        if (this.gameSetUpService.gameMode == 'X01') {
            this.gameSetUpService.throws = 3;
        }
        this.createGame.emit();
    }

    onKeyEnter(event, inputId) {

        if (inputId < this.gameSetUpService.teamCount - 1 && event.keyCode === 13) {

            event.preventDefault();
            const inputs =
                Array.prototype.slice.call(document.querySelectorAll('input'));
            const index =
                (inputs.indexOf(document.activeElement) + 1) % inputs.length;
            const input = inputs[index];
            input.focus();
            input.select();

        } else {
            if (event.keyCode === 13) {
                this.onCreateGame();
            }
        }



    }



}



// WEBPACK FOOTER //
// ./src/app/components/set-up/set-up.component.ts